var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pms-container"},[_c('div',{staticClass:"menu-nav"},[_c('sider-bar')],1),_c('div',{staticClass:"pms-main-container"},[_c('pms-main')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }